import React, { Component } from 'react'
import styled from 'styled-components'
import { Popconfirm, Button, Form, Select, Icon, Collapse } from 'antd'
import moment from 'moment'
import NumberFormat from 'react-number-format'
import { TextMask, SpanAdapter } from 'react-text-mask-hoc'
import ContactsCollapse from './Collapse'

const { Panel } = Collapse
const FormItem = Form.Item
const Option = Select.Option

const AddItemsContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background-color: #eeeeee;
`

class Phones extends Component {
  constructor(props) {
    super(props)
    this.state = {
      attachmentDetailsVisible: false
    }
  }

  renderMask = phone => {
    const { type, number } = phone
    const mask =
      type === 'Mobile'
        ? ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
        : [
            '(',
            /[1-9]/,
            /\d/,
            /\d/,
            ')',
            ' ',
            /\d/,
            /\d/,
            /\d/,
            '-',
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            ' ',
            'e',
            'x',
            't',
            ':',
            ' ',
            /\d/,
            /\d/,
            /\d/,
            /\d/
          ]
    return <TextMask Component={SpanAdapter} value={number} mask={mask} guide />
  }

  renderElement = phone => {
    const { handleRowPhoneClick } = this.props
    const { number, type, created_date } = phone
    const createdDate = moment.utc(created_date).format('M/D/YYYY')
    const numberMask = this.renderMask(phone)
    return (
      <Panel key={number} header={numberMask}>
        <div className="row">
          <div className="col-md-5">
            <div className="jobDetailsHeader">Number:</div>
            {numberMask}
          </div>
          <div className="col-md-2">
            <div className="jobDetailsHeader">Type:</div>
            <span>{type}</span>
          </div>
          <div className="col-md-3">
            <div className="jobDetailsHeader">Created:</div>
            <span>{createdDate}</span>
          </div>
          <div className="col-md-2">
            <div className="jobDetailsHeader">Edit:</div>
            <Button onClick={() => handleRowPhoneClick(phone)}>
              <Icon type="edit" />
            </Button>
          </div>
        </div>
      </Panel>
    )
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const {
      currentPhoneData,
      phoneAddEditContainer,
      onPhoneInputChange,
      handleTogglePhoneEditArea,
      handleAddEditPhone,
      handleDeletePhone,
      onChangePhoneType,
      phoneType
    } = this.props
    const phones = this.props.phones || []
    return (
      <div>
        <div className="row">
          <div className="col-md-6">
            <h4>Phone Numbers</h4>
          </div>
          <div className="col-md-6 d-flex justify-content-end">
            <Button icon="plus" onClick={handleTogglePhoneEditArea} className="ml-2">
              {' '}
              Add Phone
            </Button>
          </div>
        </div>
        {phoneAddEditContainer && (
          <AddItemsContainer>
            <div className="row">
              <div className="col-md-6">
                <FormItem label="Type">
                  {getFieldDecorator('type', {
                    rules: [
                      {
                        required: false,
                        message: 'You must choose a type'
                      }
                    ],
                    initialValue: currentPhoneData ? currentPhoneData.type : ''
                  })(
                    <Select
                      placeholder="Choose the type"
                      onChange={onChangePhoneType}
                      style={{ width: '100%' }}
                    >
                      <Option value="Work">Work</Option>
                      <Option value="Mobile">Mobile</Option>
                      <Option value="Personal">Personal</Option>
                      <Option value="Fax">Fax</Option>
                    </Select>
                  )}
                </FormItem>
              </div>
              <div className="col-md-6">
                {phoneType !== 'Mobile' && (
                  <FormItem label="Phone Number">
                    {getFieldDecorator('number_new', {
                      rules: [
                        {
                          required: false,
                          message: 'Mobile Number cannot be blank.'
                        }
                      ],
                      initialValue: currentPhoneData ? currentPhoneData.number : ''
                    })(
                      <NumberFormat
                        format="(###) ###-#### ext:####"
                        mask="_"
                        onValueChange={values => {
                          const e = { target: values.value }
                          onPhoneInputChange(e)
                        }}
                        className="ant-input"
                      />
                    )}
                  </FormItem>
                )}
                {phoneType === 'Mobile' && (
                  <FormItem label="Phone Number">
                    {getFieldDecorator('number_new', {
                      rules: [
                        {
                          required: false,
                          message: 'Mobile Number cannot be blank.'
                        }
                      ],
                      initialValue: currentPhoneData ? currentPhoneData.number : ''
                    })(
                      <NumberFormat
                        format="(###) ###-####"
                        mask="_"
                        onValueChange={values => {
                          const e = { target: values.value }
                          onPhoneInputChange(e)
                        }}
                        className="ant-input"
                      />
                    )}
                  </FormItem>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 d-flex justify-content-end">
                <Popconfirm
                  title="Are you sure you want to delete this record?"
                  onConfirm={handleDeletePhone}
                  onCancel={this.cancelDelete}
                  okText="Yes"
                  cancelText="No"
                >
                  {currentPhoneData && <Button type="danger" icon="delete" className="mr-2" />}
                </Popconfirm>
                <Button onClick={handleAddEditPhone}>{currentPhoneData ? 'Edit' : 'Add'}</Button>
              </div>
            </div>
          </AddItemsContainer>
        )}
        <ContactsCollapse emptyText="There are no phones for this contact">
          {phones.map(this.renderElement)}
        </ContactsCollapse>
      </div>
    )
  }
}

export default Form.create()(Phones)



// WEBPACK FOOTER //
// ./src/components/contacts/Phones.js